import { createSlice } from "@reduxjs/toolkit";

// Load initial state from localStorage
const loadBookmarks = () => {
  try {
    const stored = localStorage.getItem("bookmarkedMentors");
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.error("Failed to load bookmarks from localStorage", e);
    return [];
  }
};

const bookmarkSlice = createSlice({
  name: "bookmark",
  initialState: {
    bookmarkedMentors: loadBookmarks(),
  },
  reducers: {
    toggleBookmark: (state, action) => {
      const newMentor = action.payload;
      const mentorName = newMentor.name;

      if (!mentorName) {
        console.warn("⚠️ Cannot toggle bookmark: mentor has no name.");
        return;
      }

      const index = state.bookmarkedMentors.findIndex(
        (mentor) => mentor.name === mentorName
      );

      if (index !== -1) {
        state.bookmarkedMentors.splice(index, 1); // remove
      } else {
        state.bookmarkedMentors.push(newMentor); // add
      }

      // Save updated state to localStorage
      try {
        localStorage.setItem(
          "bookmarkedMentors",
          JSON.stringify(state.bookmarkedMentors)
        );
      } catch (e) {
        console.error("Failed to save bookmarks to localStorage", e);
      }
    },
  },
});

export const { toggleBookmark } = bookmarkSlice.actions;
export default bookmarkSlice.reducer;
